module.exports = __webpack_public_path__ + "static/PumpkinPals-28a2151bf51647dd8e1f3325afd0a01a.jpg";